import { Grid, TextField } from "@mui/material";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function DocData() {
  const location = useLocation();
  const data = location.state.data;
  useEffect(() => {
    const iframe = document.querySelector("iframe");
    if (iframe?.src) iframe.src = location.state.file;
  }, []);
  return (
    <div style={{ margin: 10 }}>
      <iframe
        src=""
        style={{ height: "800px", width: "100%", marginTop: 10 }}
      ></iframe>
    </div>
  );
}
